import React from "react";
import { Card, CardBody, Table } from "reactstrap";

const CaseDetailsTable = ({ caseDetails }) => {
  if (!caseDetails || !caseDetails.caseId) {
    return null;
  }

  return (
    <Card className="mt-3 mb-0 border">
      <CardBody className="py-3">
        <h6 className="mb-3">Case Details</h6>
        <Table bordered responsive className="mb-0">
          <tbody>
            <tr>
              <th width="30%">Case ID</th>
              <td>{caseDetails.caseId}</td>
            </tr>
            <tr>
              <th>Case Name</th>
              <td>{caseDetails.caseName || "-"}</td>
            </tr>
            <tr>
              <th>Corporate Name</th>
              <td>{caseDetails.corporateName || "-"}</td>
            </tr>
            <tr>
              <th>Counterparty Name</th>
              <td>{caseDetails.counterpartyName || "-"}</td>
            </tr>
            <tr>
              <th>Status</th>
              <td>{caseDetails.status || "-"}</td>
            </tr>
            {typeof caseDetails.hasFinancialFormData === "boolean" && (
              <tr>
                <th>Financial Form Data</th>
                <td>{caseDetails.hasFinancialFormData ? "Present" : "Not present"}</td>
              </tr>
            )}
            {typeof caseDetails.hasExecutiveSummaryFinancialData === "boolean" && (
              <tr>
                <th>Executive Summary Financial Sections</th>
                <td>
                  {caseDetails.hasExecutiveSummaryFinancialData
                    ? "Present"
                    : "Not present"}
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </CardBody>
    </Card>
  );
};

export default CaseDetailsTable;
